import { Link } from "react-router-dom";
import { adminProcApi } from "../../api";
import { ProcError, ProcLoading, ProcPagination } from "../../components/ProcurementLayout";
import { ProcStatusBadge } from "../../components/ProcStatusBadge";
import { useAsyncData, useMutation, usePageState } from "../../hooks";

export default function DelistingListPage() {
  const { page, size, setPage, state } = usePageState();

  const { data, loading, error, reload } = useAsyncData(
    () => adminProcApi.listDelistings({ page: state.page, size: state.size }),
    [state.page, state.size],
  );

  const { mutate: doApprove } = useMutation((id: number) =>
    adminProcApi.approveDelisting(id).then(() => reload()),
  );

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Supplier Delistings</h1>
        </div>
        <Link to="/procurement/admin/delistings/new" className="rounded-xl bg-emerald-700 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-800">
          New Delisting
        </Link>
      </div>

      {loading && <ProcLoading />}
      {error && <ProcError message={error} />}

      {!loading && !error && data && (
        <>
          <div className="rounded-2xl border bg-white shadow-sm overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="bg-slate-50 text-xs uppercase text-slate-500">
                <tr>
                  <th className="px-4 py-3">Serial No</th>
                  <th className="px-4 py-3">Supplier</th>
                  <th className="px-4 py-3">Status</th>
                  <th className="px-4 py-3">Date</th>
                  <th className="px-4 py-3 text-right">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {data.content.length === 0 && (
                  <tr><td colSpan={5} className="px-4 py-8 text-center text-slate-400">No delisting records found.</td></tr>
                )}
                {data.content.map((r) => (
                  <tr key={r.id} className="hover:bg-slate-50">
                    <td className="px-4 py-3 font-mono font-semibold text-slate-900">{r.serialNo}</td>
                    <td className="px-4 py-3 text-slate-700">{r.supplierName}</td>
                    <td className="px-4 py-3"><ProcStatusBadge value={r.status} /></td>
                    <td className="px-4 py-3 text-slate-500">{r.reviewDate ? new Date(r.reviewDate).toLocaleDateString() : "—"}</td>
                    <td className="px-4 py-3 text-right space-x-3">
                      {r.status === "PENDING" && (
                        <button
                          type="button"
                          onClick={() => doApprove(r.id)}
                          className="rounded-lg bg-emerald-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-emerald-700"
                        >
                          Approve
                        </button>
                      )}
                      <Link to={`/procurement/admin/delistings/${r.id}`} className="font-semibold text-emerald-700 hover:underline">View</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <ProcPagination
            page={data.number}
            totalPages={data.totalPages}
            totalElements={data.totalElements}
            onPage={setPage}
          />
        </>
      )}
    </div>
  );
}
